import axios from '../utils/axios';

const baseUrl = `/api/quotation`;

export const hasQuotation = async (
  company: string,
  custId: string,
  blockNo: string,
): Promise<boolean> => {
  const requestUrl = `${baseUrl}/${company}/${custId}/${blockNo}/hasQuotation`;
  console.log('===== url ===>', requestUrl);
  const res = await axios.get<boolean>(requestUrl);
  console.log('===== res ===>', res);
  //return true/false
  return res.data;
};
